import { render, staticRenderFns } from "./PassWordChanging.vue?vue&type=template&id=24d02c38&scoped=true"
import script from "./PassWordChanging.vue?vue&type=script&lang=js"
export * from "./PassWordChanging.vue?vue&type=script&lang=js"
import style0 from "./PassWordChanging.vue?vue&type=style&index=0&id=24d02c38&prod&lang=css"
import style1 from "./PassWordChanging.vue?vue&type=style&index=1&id=24d02c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d02c38",
  null
  
)

export default component.exports